import env from 'utils/env';
import request from './request';
import requestJson from './requestJson';

export const downloadProductsCSV = () => {
  return `${env.refillsApi}/products`;
};

export const createProduct = (formData) => {
  const endpoint = `${env.aceApi}/1/admin/products`;
  const data = JSON.stringify(formData);
  return request(
    endpoint,
    'POST',
    { 'Content-Type': 'application/json' },
    data
  );
};

export const uploadProducts = async (selectedFile) => {
  const endpoint = `${env.refillsApi}/products`;
  const formData = new FormData();
  formData.append('file', selectedFile);
  return request(endpoint, 'POST', null, formData, true, true);
};

export const fetchDefaultCampaign = async () => {
  const endpoint = `${env.refillsApi}/campaigns`;
  const campaigns = await request(endpoint, 'GET');
  return campaigns.find((c) => c.default);
};

export const importCampaign = (originCampaignId, isCurrentSeason = true) => {
  const endpoint = `${env.refillsApi}/campaigns/ingest/${originCampaignId}?default=${isCurrentSeason}`;
  const headers = { Accept: 'application/vnd.fabfitfun.v1+json' };
  return requestJson(endpoint, 'POST', headers);
};

export const getChainingJobStatus = () => {
  const endpoint = `${env.refillsApi}/chain/last-ran`;

  return request(endpoint, 'GET', { 'Content-Type': 'application/json' });
};

export const runChainJob = () => {
  const endpoint = `${env.refillsApi}/chain`;

  return request(endpoint, 'POST', { 'Content-Type': 'application/json' });
};
